export interface VariantImageMetadata {
  potSize: string;
  potType: string;
  potColor: string;
  productId: string;
  variantId?: string;
}

export interface VariantImage {
  id: string;
  product_id: string;
  variant_id?: string | null;
  pot_size: string;
  pot_type: string;
  pot_color: string;
  image_url: string;
  metadata: any; // Use any to match Supabase Json type
  uploaded_by?: string | null;
  created_at: string;
  updated_at: string;
  alt_text?: string | null;
  sort_order?: number;
  is_cover?: boolean;
}

export interface ImageUploadResult {
  success: boolean;
  imageUrl?: string;
  error?: string;
}

export interface ImageUploadProvider {
  upload(file: File, metadata: VariantImageMetadata): Promise<ImageUploadResult>;
  delete(imageId: string): Promise<void>;
  getPublicUrl(path: string): string;
}

export interface VariantImageKey {
  color: string;
  size: string;
  type: string;
}

export const generateVariantImageKey = (metadata: VariantImageMetadata): string => {
  return `${metadata.potColor}:${metadata.potSize}:${metadata.potType}`;
};

export interface PendingVariantImage {
  file: File;
  preview: string; // Blob URL for preview
  imageUrl: string; // Public URL from storage
  altText?: string;
  sortOrder: number;
  variantId: string; // Temporary variant ID (temp-xxx)
}